/**
 * Shift helper utilities used by the shift planning feature.
 * Pure functions with no external dependencies.
 */

import type { ShiftStatusType, ShiftTypeValue } from '@/types/shifts';
import { ShiftStatus, ShiftType } from '@/types/shifts';

// ============================================================================
// Types
// ============================================================================

export type ViewMode = 'byGroup' | 'byEmployee';

// ============================================================================
// Type Guards
// ============================================================================

/**
 * Type guard to check if a value is a valid ShiftStatusType
 */
export function isValidShiftStatus(value: unknown): value is ShiftStatusType {
  return (
    typeof value === 'string' &&
    Object.values(ShiftStatus).includes(value as ShiftStatusType)
  );
}

/**
 * Type guard to check if a value is a valid ShiftTypeValue
 */
export function isValidShiftType(value: unknown): value is ShiftTypeValue {
  return (
    typeof value === 'string' &&
    Object.values(ShiftType).includes(value as ShiftTypeValue)
  );
}

// ============================================================================
// Display Helpers
// ============================================================================

/**
 * Generate initials from first and last name.
 */
export function getEmployeeInitials(
  firstname?: string,
  lastname?: string
): string {
  const first = firstname?.trim()[0] || '';
  const last = lastname?.trim()[0] || '';
  return (first + last).toUpperCase() || '?';
}
